import React from 'react';
import tsl from './../../tsl';
import axios from 'axios';
import { addAlert } from '../../../actions/Alerts';
import {connect} from 'react-redux';

const imgStyle = { cursor: "pointer", height: '60px', maxWidth: '150px' };
const divStyle = { cursor: "pointer", height: '60px', width: '150px', textAlign: 'center', lineHeight: '60px', backgroundColor: '#ccc' };

class LogoUpload extends React.Component {

  handleOpenDialog = () => {
    this._element.click();
  };


  handleUpload = (e) => {
    if (e.target.files.length == 0) return;

    const file = e.target.files[0];

    if (file.type.indexOf('image/') !== 0) {
      this.props.addAlert(tsl('settings.logo.incorrect_file_type'), 'error');
      return;
    }

    var data = new FormData();
    data.append('uploadedFile', file);

    axios.post('/files/upload', data)
      .then((res) => {
        // console.log('success upload', res.data);

        this.props.onUpload(res.data);
      })
      .catch(function (err) {
        console.error(err);
      });
  };
  
  render() {
    return (
      <div>
        {
          this.props.file ?
          <img
            style={imgStyle}
            src={this.props.file.url}
            onClick={this.handleOpenDialog}
          /> :
          <div
            style={divStyle}
            onClick={this.handleOpenDialog}
          >
            {tsl('Click to upload')}
          </div>
        }
        <input
          style={{ display: 'none' }}
          type="file"
          name="logo"
          ref={e => this._element = e}
          onChange={this.handleUpload}
        />
      </div>
    )
  }
}

export default connect(() => ({}), { addAlert })(LogoUpload);


// WEBPACK FOOTER //
// ./app/used/settings/LogoUpload.js